import React from 'react';

import BillingInformationForm from 'components/common/BillingInformationForm/BillingInformationForm';
import BillingInformationData from 'components/common/BillingInformationData/BillingInformationData';

import Modal from '@core/components/Modal/Modal';
import ActionButton from '@core/components/actionbutton/ActionButton';
import Spinner from '@core/components/spinner/Spinner';

import { useQuery, useMutation } from 'react-query';
import { billingAddressService } from 'services/auth';

import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';

import { isUserLoggedIn } from 'utils/authentication';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import BillingInfoIcon from 'assets/icons/billing-info-icon.svg';
import BillingInfoIconimg from 'assets/icons/billing-info-icon.svg?url';
import DeleteIcon from 'assets/icons/delete-icon.svg';
import EditIcon from 'assets/icons/edit-icon.svg';
import PlusIcon from 'assets/icons/plus-rounded-circle.svg';

import { Edit } from 'iconsax-react';

import classes from './BillingInformation.module.scss';
import { getErrorText } from 'utils/geterrortext';

const BillingInformation = () => {
	const { ToastContainer, toast } = UseToast();
	const {
		data,
		isLoading,
		refetch: refetchBillingAddress
	} = useQuery(['billing-address', isUserLoggedIn()], billingAddressService.GET, {
		cacheTime: 20 * 60 * 1000
	});
	const { mutate: deleteBillingInfo } = useMutation(billingAddressService.DELETE, {
		onSuccess: (response) => {
			refetchBillingAddress();
			response.data.message && toast(response.data.message, 'success');
			destroyDeleteBillingAddress();
		},
		onError: (error) => {
			toast(getErrorText(error), 'error');
		}
	});
	const {
		show: showAddBillingAddress,
		showModal: showAddBillingAddressHandler,
		destroyModal: destroyAddBillingAddress
	} = UseModal();
	const {
		show: showDeleteBillingAddress,
		showModal: showDeleteBillingAddressHandler,
		destroyModal: destroyDeleteBillingAddress
	} = UseModal();

	const biliingFormSubmit = async () => {
		await refetchBillingAddress();
		destroyAddBillingAddress();
	};
	return (
		<>
			{data && !isLoading ? (
				<>
					<div
						className={`d-flex flex-row align-items-center justify-content-end justify-content-md-between mb-3 mb-md-3 ${classes['billing-info-header']}`}>
						<h2 className="d-none d-md-flex align-items-center gap-4">
							{/* <BillingInfoIcon />  */}
							Billing Information
						</h2>
						{data.data.country_iso &&
							data.data.postal_code &&
							data.data.city &&
							data.data.address_line_1 && (
								<div className="d-flex flex-row gap-2">
									<ActionButton
										kind="secondary"
										onClick={showDeleteBillingAddressHandler}
										data-testid="billing-delete-btn">
										<DeleteIcon />
									</ActionButton>
									<ActionButton
										kind="secondary"
										onClick={showAddBillingAddressHandler}
										data-testid="billing-edit-btn">
										<div className='d-flex gap-2'>
											<Edit size={24} />
											Update
										</div>
									</ActionButton>
								</div>
							)}
					</div>
					{data.data.country_iso &&
						data.data.postal_code &&
						data.data.city &&
						data.data.address_line_1 ? (
						<BillingInformationData billingAddress={data.data} />
					) : (
						<div
							className={`d-flex flex-column justify-content-between ${classes['billing-information-wrapper']}`}>
							<div className={`${classes['billing-information-wrapper__add']}`}>
								<img src={BillingInfoIconimg} alt="empty-billing-info" />
								<p>You have not added your billing information yet</p>
								<ActionButton onClick={showAddBillingAddressHandler}>
									<PlusIcon />
									Add Billing information
								</ActionButton>
							</div>
							<ActionButton onClick={showAddBillingAddressHandler}>
								<PlusIcon />
								Add Billing information
							</ActionButton>
						</div>
					)}
				</>
			) : (
				<div className="d-flex align-items-center justify-content-center w-100 py-5">
					<Spinner />
				</div>
			)}
			<ToastContainer />
			<Modal
				title="Add billing information"
				show={showAddBillingAddress}
				closeHandler={destroyAddBillingAddress}
				type={MOBILE_FULLSCREEN}>
				<div className={`${classes['billing-address-form-modal']}`}>
					<BillingInformationForm
						callback={biliingFormSubmit}
						toast={toast}
						billingAddress={data?.data}
					/>
				</div>
			</Modal>
			<Modal
				header={false}
				show={showDeleteBillingAddress}
				closeHandler={destroyDeleteBillingAddress}>
				<div
					className={`d-flex flex-column align-items-center gap-4 ${classes['delete-blling-info-modal']}`}>
					<BillingInfoIcon />
					<h3>Remove Billing Information?</h3>
					<p>Are you sure you want to remove your billing information?</p>
					<div className="w-100 d-flex flex-row align-items-center justify-content-end">
						<ActionButton
							kind="blank"
							style={{ color: 'black' }}
							onClick={destroyDeleteBillingAddress}>
							Cancel
						</ActionButton>
						<ActionButton kind="blank" onClick={deleteBillingInfo}>
							Remove
						</ActionButton>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default BillingInformation;
